import enLocale from './en'
export default {
  ...enLocale,
  language: 'Langue',
  confirm: 'Confirmer',
  go: 'Aller',
  status: 'Statut',
  balance: 'Solde',
  cash: 'Espèces',
  createNew: 'Créer',
  home: 'Accueil',
  market: 'Marché',
  markets: 'Marchés',
  portfolio: 'Portefeuille',
  license: 'Licence',
  withdraw: 'Retirer',
  auditChecking: 'Vérification en cours',
  insufficientFunds: 'Fonds insuffisants',
  buy: 'Acheter',
  history: 'Historique',
  seeMore: 'Voir plus',
  theme: 'Thème',
  network: 'Réseau',
  walletBalance: 'Solde du portefeuille',
  collect: 'Collecter',
  approve: 'Approuver',
  ticket: 'Licence',
  category: 'Catégorie',
  sortBy: 'Trier par',
  issue: 'Publier',
  detail: 'Détail',
  stakingType: 'Garantie',
  stakingTypeInfo: "Pour éviter une confirmation malveillante des résultats, veuillez staker des tokens ou l'actuel NFT.",
  subscriptionAmount: "Montant d'achat",
  subscription: 'Souscription',
  subscribe: 'Acheter',
  max: 'Max',
  marketClosed: 'Marché fermé',
  deposit: 'Ajouter',
  verifiedNFT: 'Vérifier la licence',
  select: 'Sélectionner',
  selected: 'Sélectionné',
  moreNFT: 'Obtenir plus de licences',
  forecastEvent: 'Événement',
  subscribeEndDate: 'Dernière heure de trading',
  specifyExpiryDate: "Spécifier l'heure d'expiration",
  endDate: 'Heure de fin',
  validityPeriod: "Heure d'expiration",
  marketEndDate: "Heure d'expiration",
  liquidityMin: 'Liquidité minimale',
  premiumMin: 'Prime min',
  paymentCurrency: 'Devise de paiement',
  defaultOdds: 'Levier par défaut',
  setDefaultOdds: 'Définir le levier',
  minInvestAmout: "Définir le montant d'investissement minimum",
  depositMargin: 'Ajouter la liquidité',
  totalPayment: 'Paiement total',
  rewards: 'Récompenses',
  rewardRate: 'Taux de récompense',
  release: 'Libérer',
  fee: 'Frais',
  marginFeeRate: 'Taux de frais',
  cdsInfoOne: "Pour publier un produit de prédiction, vous devez staker la marge, définir le levier par défaut et le montant minimum d'investissement.",
  cdsInfoTwo: 'La marge non participée peut être retirée à tout moment.',
  cdsInfoThree: "Si plus d'un utilisateur conteste le jugement, la gouvernance communautaire déterminera si l'événement s'est produit.",
  deposited: 'Investi',
  issued: 'Publié',
  depositedCDS: 'produits investis',
  totalProfit: 'Profit total',
  allOrDeposited: 'Total/Investi',
  rewardsOrProfit: 'Récompenses/Profit',
  estimatedInvested: 'Estimé/Investi',
  profit: 'Profit',
  yesterdayProfit: 'Profit hier',
  eventConfirming: "Confirmation de l'événement",
  appeal: 'Contesté',
  appealing: 'En contestation',
  appealFailed: 'Contestation échouée',
  occured: 'Survenu',
  notOccured: 'Non survenu',
  governanceMechanism: "La gouvernance est initiée si le nombre d'appel dépasse une personne.",
  appealLimit: "Le nombre d'appel ne dépasse pas une personne.",
  waitResult: "En attente du résultat d'appel",
  frozenMargin: 'Marge gelée',
  marginBalance: 'Solde de marge',
  endTime: 'Compte à rebours jusqu’à la fin',
  guaranteeing: 'En cours',
  guaranteeingEvent: 'Prédiction en cours',
  confirmsEventAdvance: 'Confirmé à l’avance',
  waitConfirmation: 'En attente de confirmation',
  triggerEvent: "L'événement est confirmé comme survenu.",
  notTriggerEvent: "L'événement n'est pas survenu.",
  defaultChallenging: 'Survenu — contestation',
  notDefaultChallenging: 'Non survenu — contestation',
  defaultChallengeFailed: 'Survenu — contestation échouée',
  notDefaultChallengeFailed: 'Non survenu — contestation échouée',
  defaultWaitingResult: 'Survenu — gouvernance en attente',
  notDefaultWaitingResult: 'Non survenu — gouvernance en attente',
  defaultGovernanceMechanism: 'Survenu — gouvernance confirmée',
  notDefaultGovernanceMechanism: 'Non survenu — gouvernance confirmée',
  cancel: 'Annuler',
  defaultAhead: 'Survenu à l’avance',
  occur: 'Survenu',
  notOccur: 'Non survenu',
  stakingToChallenge: 'Stake pour contester',
  challenged: 'Contesté',
  checking: 'En cours de vérification',
  fail: 'Échec',
  appealInfoOne: 'Si vous pensez que la décision de cet événement de prédiction est erronée, vous pouvez « Contester » pour déclencher la gouvernance.',
  check: 'Vérifier',
  contentIllegal: "L'événement comporte du contenu illégal, veuillez le modifier avant de publier",
  subscribed: 'produits investis',
  receivingCompensation: 'En attente',
  received: 'Paiement total',
  receive: 'Recevoir',
  compensationAmount: 'Montant de compensation survenu',
  liquidity: 'Liquidité',
  injectLiquidity: 'Injecter la liquidité',
  uRLContent: 'URL/Contenu',
  resolutionSource: 'Source de décision',
  textareaInfo: 'Veuillez décrire brièvement cet événement.',
  share: 'Partager',
  USDT: 'USDT',
  donations: 'Dons',
  issueMsgPleaseSelectLicense: 'Veuillez sélectionner une licence',
  issueMsgLicenseCannotBeStaked: 'La licence ne peut pas être stakée',
  issueMsgNetworkNotConnected: 'Réseau non connecté',
  issueMsgEventEmpty: 'Événement vide',
  issueMsgSelectLicense: 'Sélectionnez une licence',
  issueMsgLastTradingDateEmpty: 'La dernière heure de trading est vide',
  issueMsgExpirationDateEmpty: "L'heure d'expiration est vide",
  issueMsgLastTradingDateGreaterThanToday: "La dernière heure de trading doit être postérieure à aujourd'hui",
  issueMsgLastTradingDateGreaterThanExpirationDate: "La dernière heure de trading est postérieure à l'heure d'expiration",
  issueMsgEventEndDateGreaterThanRentalEndDate: "L'heure de fin de l'événement {eventEndDate} est supérieure à l'heure de fin de la location {rentalEndDate}",
  issueMsgOptionsEmpty: "Les options ne peuvent pas être vides",
  issueMsgOptionsLessThanTwo: "Au moins deux options sont requises",
  issueMsgOptionEmpty: "Le contenu de l'option ne peut pas être vide",
  issueMsgOptionRepeated: "Le contenu de l'option est dupliqué",
  issueMsgLastTradingDateGreaterThanToday: "La dernière date doit être postérieure à aujourd'hui",
  issueMsgLastTradingDateGreaterThanExpirationDate: "La dernière date est supérieure à la date d’expiration",
  issueMsgLicenseError: 'Erreur de licence',
  issueMsgTicketError: 'Erreur de ticket',
  issueMsgEventEndDateGreaterThanRentalEndDate: "La date de fin {eventEndDate} est supérieure à la date de fin de location {rentalEndDate}",
  issueMsgInsufficientBalance: 'Solde insuffisant',
  issueMsgTransactionFailed: 'Échec de la transaction',
  issueMsgIssueSuccess: 'Publication réussie',
  issueMsgTransactionCancelled: 'Transaction annulée',
  short: {
    confirmsEventAdvance: 'Survenu à l’avance',
    waitConfirmation: 'En attente de confirmation',
    defaultChallenging: 'Survenu — contestation',
    notDefaultChallenging: 'Non survenu — contestation',
    defaultChallengeFailed: 'Survenu — contestation échouée',
    notDefaultChallengeFailed: 'Non survenu — contestation échouée',
    defaultWaitingResult: 'Survenu — gouvernance',
    notDefaultWaitingResult: 'Non survenu — gouvernance',
    defaultGovernanceMechanism: 'Survenu — gouvernance confirmée',
    notDefaultGovernanceMechanism: 'Non survenu — gouvernance confirmée'
  },
  wallet: {
    openWallet: 'Ouvrir le portefeuille',
    connectWallet: 'Connecter le portefeuille',
    connectingWallet: 'Connexion au portefeuille',
    connectYourWallet: 'Connectez votre portefeuille',
    disconnect: 'Déconnecter',
    wrongNetwork: 'Mauvaise chaîne'
  },
  NFT: {
    getPrediLicense: 'Obtenir la licence Predi',
    referralRewards: 'Récompenses de parrainage',
    mintYourLicence: 'Minter votre licence',
    usageRights: 'Droits d’utilisation',
    issuePredictionProducts: 'Publier des produits de prédiction',
    governance: 'Gouvernance',
    properties: 'Propriétés',
    tradable: 'Échangeable',
    rentable: 'Louable',
    usable: 'Utilisable',
    marketsToIssue: 'Marchés à publier',
    times: 'Fois',
    availableTimes: 'Fois disponibles',
    ticketId: 'ID du ticket',
    cancelRentHint: 'Cette licence est en location, annulez-la pour la vendre.',
    sell: 'Vendre',
    rent: 'Louer',
    share: 'Partager',
    USDT: 'USDT',
    common: 'Commun',
    scarcity: 'Rareté',
    attributive: 'Attributif',
    numbers: 'Nombre d’émissions',
    issueTip: 'Publier 10 marchés/licences de prédiction',
    price: 'Prix',
    success: 'Succès',
    getNFT: 'Licence obtenue',
    issueCDS: 'Publier des marchés Predi',
    buyNow: 'Acheter maintenant',
    mintNow: 'Minter maintenant',
    rule: 'Règle',
    comingSoon: 'Bientôt !',
    type: 'Type',
    from: 'De',
    to: 'À',
    me: 'Moi',
    rented: 'Loué',
    sold: 'Vendu',
    tabGetLicense: 'Obtenir la licence',
    tabMyLicense: 'Ma licence',
    bought: 'Acheté',
    boughtProducts: 'Produits achetés',
    investedProducts: 'Produits investis',
    issuedProducts: 'Produits publiés',
    positions: 'Positions',
    options: 'Options',
    all: 'Tous',
    volume: 'Volume',
    newest: 'Nouveaux',
    price: 'Prix',
    pending: 'En attente',
    audit: 'Audit',
    loading: 'Chargement',
    home: 'Accueil',
    market: 'Marché',
    markets: 'Marchés',
    portfolio: 'Portefeuille',
    license: 'Licence',
    empowering: 'Donner du pouvoir aux visionnaires qui prédisent l’avenir',
    myPositions: 'Mes positions',
    challengeCredit: 'Crédit de contestation',
    challengeStatus: 'Statut de contestation',
    succeed: 'Réussi',
    wait: 'Attente',
    return: 'Retour',
    createYourOwnMarket: 'Créer votre propre marché',
    waitChallenge: 'Événement en attente de contestation.',
    waitingGovernanceResult: 'Événement en attente de gouvernance.',
    eventFinished: 'Événement terminé.',
    cancelled: 'Annulé',
    predictionProduct: 'Produit de prédiction',
    complaintCountdown: 'Compte à rebours de contestation',
    setResult: 'Définir le résultat',
    challenge: 'Contester',
    recycleTicket: 'Recycler le ticket',
    eventCancelled: "L'événement a été annulé.",
    auditChecking: 'Vérification en cours',
    insufficientFunds: 'Fonds insuffisants',
    buyTicket: 'Acheter un ticket',
    buy: 'Acheter',
    listYourToken: 'Lister votre token',
    setResultModalTitle: 'Définir le résultat :',
    cancelModalTitle: 'Annuler',
    cancelIrreversible: 'Annulation irréversible.',
    challengeModalTitle: 'Contester',
    challengeStakeIntro: 'S’il y a divergence de fait, vous serez remboursé.',
    challengeStakeButton: 'PRDS pour contester',
    history: 'Historique',
    seeMore: 'Voir plus',
    licenses: 'Licences',
    prediLicense: 'Licence Predi',
    issuableQuantity: 'Quantité publiable',
    disabled: 'Désactivé',
    battleImage: 'Image de bataille',
    upload: 'Téléverser',
    showSample: 'Voir l’exemple',
    battleInformation: 'Informations',
    baseToken: 'Jeton de base',
    collateral: 'Garantie',
    currentLicense: 'Licence actuelle',
    predictionProject: 'Projet de prédiction :',
    issueExpireIntro: "À l'heure d'expiration, ceux qui ont choisi la bonne option se partageront les jetons du pool du produit selon leurs parts de participation.",
    issueParticipateUntil: 'Participation possible jusqu\'à',
    issueConfirmAdvance: "Le résultat peut être confirmé à l'avance par l'émetteur si l'événement survient avant l'heure d'expiration.",
    issueChallengeWithin7Days: 'Contestable dans les 7 jours.',
    issueAttention: 'Predi favorise divertissement/social. Jeux d’argent interdits.',
    eventSampleTitle: 'Événement',
    issueSampleCrypto: "Crypto] Quelle sera la fourchette de prix du Bitcoin fin 2025 ?",
    issueSampleFinance: "[Finance] Quelle sera la décision de taux de la Fed américaine au T3 2025 ?",
    issueSampleTechnology: "[Technologie] Quelle entreprise lancera le premier assistant robot IA entièrement autonome ?",
    issueSampleSports: "[Sport] Quelle équipe remportera la Coupe du monde 2026 ?",
    issueSampleSociety: "[Société] Quelle plateforme aura le plus d’utilisateurs actifs mensuels en 2025 ?",
    issueSampleOthers: "[Autres] Quand la guerre Russie-Ukraine prendra-t-elle fin ?",
    issuerResult: 'Résultat de l’émetteur',
    daoResult: 'Résultat DAO',
    predictionToken: 'Token de prédiction',
    issuer: 'Émetteur',
    issuerProfit: 'Profit de l’émetteur'
  },
  claim: {
    title: 'Réclamez des PRDs gratuitement',
    subtitle: 'Obtenez vos PRDs en un clic',
    walletAddress: 'Adresse du portefeuille',
    status: 'Statut',
    connectWalletFirst: 'Veuillez d’abord connecter le portefeuille',
    eligibility: {
      claimed: 'Vous avez déjà réclamé',
      eligible: 'Vous êtes éligible',
      error: 'Erreur de vérification'
    },
    button: {
      claim: 'Réclamer',
      alreadyClaimed: 'Déjà réclamé',
      connect: 'Connecter'
    },
    footerNotice: "Chaque portefeuille peut réclamer une fois. Assurez-vous d'être sur le bon réseau.",
    messages: {
      connectFirst: 'Veuillez connecter votre portefeuille d’abord',
      claimSuccess: 'Réclamation réussie !',
      claimFailed: 'Échec, réessayez plus tard',
      txCancelled: 'Transaction annulée',
      onlyOnce: 'Chaque utilisateur ne peut réclamer qu’une fois',
      insufficientBalance: 'Solde du contrat insuffisant, réessayez plus tard'
    }
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'Veuillez saisir le contenu de recherche',
  predictionProduct: 'Produit de prédiction',
  listYourToken: 'Lister votre token',
  description: 'Description',
  positions: 'Positions',
  options: 'Options',
  all: 'Tous',
  volume: 'Volume',
  newest: 'Nouveaux',
  pending: 'En attente',
  audit: 'Audit',
  loading: 'Chargement',
  challengeCredit: 'Crédit de contestation',
  challengeStatus: 'Statut de contestation',
  succeed: 'Réussi',
  wait: 'Attente',
  return: 'Retour',
  waitChallenge: 'Événement en attente de contestation.',
  complaintCountdown: 'Compte à rebours de contestation',
  setResult: 'Définir le résultat',
  issueParticipateUntil: 'Participation possible jusqu\'à',
  specifyLastTradingDate: 'Spécifier la dernière heure de trading',
  empowering: 'Donner du pouvoir aux visionnaires qui prédisent l\'avenir',
  amount: 'Montant',
  createYourOwnMarket: 'Créer votre propre marché'
}